const usePubNubSubscriptions = () => {
  const doPubNubSubscribe = ({ pubNub, channels, callback }) => {
    const filteredChannels = channels.filter(chan => chan && chan.length > 0);

    if (filteredChannels.length > 0) {
      const subscriptionSet = pubNub.subscriptionSet({ channels: filteredChannels });
      subscriptionSet.addListener({ message: callback });
      subscriptionSet.subscribe();
    }
  };

  const doPubNubUnsubscribe = ({ pubNub, channels, callback }) => {
    pubNub.removeListener(callback);
    pubNub.unsubscribe({ channels });
  };

  return { doPubNubSubscribe, doPubNubUnsubscribe };
};

export default usePubNubSubscriptions;
